<template>
   <section id="add-workspace">
     <div class="row p-4">
     <div class="col-md-12" 
			v-if="domain_id">
     	The domain of the email must be: {{this.domain}}

		<div class="row mb-4">
			<div class="col-4">
				<label>Prenom</label>
 				 <input
                    class="form-control"
                    type="text"
                    v-model="modelform.first_name"
                    @input="handleInput()"
                  />
	     	</div>
			<div class="col-4">
			 <label>Nom</label>
 				 <input
                    class="form-control"
                    type="text"
                    v-model="modelform.last_name"
                    @input="handleInput()"
                  />
	     	</div>
			<div class="col-4">
				<label>Email</label>
 				 <input
                    class="form-control"
                    type="text"
                    v-model="modelform.email"
                  />
	     	</div>
	     </div>

	     <div class="col-md-12">
	         <button v-if="!saving" class="btn btn-sm btn-primary" @click="save">{{ $t("lang.button.save") }}</button>
	     </div>
     </div>
     <div v-else>You must add a domain first.</div>
     <span
       v-if="saving"
      class="loadingres mr-2 ml-2 spinner-border loading-spinner"></span>
     </div>
   </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VueFormGenerator from "vue-form-generator";
import { usersService,workspaceService } from "@/_services";

export default {
    props: {
        user_id: false,
    },
	 created() {
	 	workspaceService.getWorkspaceDomainByUser(this.user_id).then((result) => {
	 	if(result[0] !== undefined){
	        this.domain = result[0].domain
	        this.domain_id = result[0].id
	        this.workspace_id = result[0].workspace_id
	        this.client_id = result[0].client_id
        }
      });
	 },
  	watch: {
	    modelform(newValue, oldValue) {
	    //   console.log('miVariable ha cambiado de valor.');
	    //   console.log('Nuevo valor:', newValue);
	    //   console.log('Valor anterior:', oldValue);
	    }
    },
    data() {
        return {
        	saving:false,
        	domain: false,
        	domain_id: false,
        	workspace_id:false,
        	client_id:false,
            target: {

            },
            editing: false,
            editingEmail: "",
            alertMessage: "",
			modelform:{
                first_name: "",
                last_name: "",
                email: ""
            }
		 }
	
		},
		methods: {
			handleInput(){
				this.modelform.email = this.getDomainProcessed(this.modelform.first_name)+"."+this.getDomainProcessed(this.modelform.last_name)+"@"+this.domain
			},
	  		getDomainProcessed(domain){
		  		domain = domain.replace(/\s/g, '');
			  	domain = domain.toLowerCase();
		  		return domain
		    },
			save(){
				if(this.modelform.email.indexOf('@'+this.domain) < 0){
				 	this.$swal({
                            type: "error",
                            title: this.$t("lang.label.error"),
                            text: "The domain of the email must be: " + this.domain,
                            showConfirmButton: false,
                            timer: 1900,
                        });

                        return;
				}
				this.saving = true;
				this.modelform.workspace_id = this.workspace_id
				this.modelform.client_id = this.client_id
				workspaceService.addEmail(this.user_id,this.modelform).then((result) => {	
					
					this.$emit("done");

		      	});
			}
		}
	}
</script>